<div class="rating-queue">
  <header class="rating-queue__head">
    <div>
      <h2>Рейтинг брендов</h2>
      <p>
        Бренды без рейтинга — сверху те, что мы продаём чаще всего и что чаще попадают в подбор.
        Рейтинг задаёт ярус предложения: 5 — «Самое лучшее», 3 — «Средние», 1–2 — «Ниже среднего».
      </p>
    </div>
    <button mat-stroked-button type="button" (click)="reload()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
      Обновить
    </button>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <p class="rating-queue__empty" *ngIf="!loading && !items.length">
    Все бренды, которые встречаются в продажах и подборе, уже с рейтингом.
  </p>

  <table mat-table [dataSource]="items" *ngIf="items.length" class="rating-queue__table">
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Бренд</th>
      <td mat-cell *matCellDef="let item">
        <a [routerLink]="['/brand', item.id]">{{ item.description }}</a>
        <span class="rating-queue__oe" *ngIf="item.oe">оригинал</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sales">
      <th mat-header-cell *matHeaderCellDef>Продажи за год</th>
      <td mat-cell *matCellDef="let item">{{ item.sales_365 }}</td>
    </ng-container>

    <ng-container matColumnDef="hits">
      <th mat-header-cell *matHeaderCellDef>В подборе</th>
      <td mat-cell *matCellDef="let item">{{ item.match_hits }}</td>
    </ng-container>

    <ng-container matColumnDef="products">
      <th mat-header-cell *matHeaderCellDef>Карточек</th>
      <td mat-cell *matCellDef="let item">{{ item.products }}</td>
    </ng-container>

    <ng-container matColumnDef="rating">
      <th mat-header-cell *matHeaderCellDef>Рейтинг</th>
      <td mat-cell *matCellDef="let item">
        <div class="rating-queue__buttons">
          <button
            *ngFor="let rating of ratingOptions"
            mat-stroked-button
            type="button"
            class="rating-queue__button"
            [disabled]="isSaving(item)"
            (click)="setRating(item, rating)"
          >
            {{ rating }}
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</div>
